<div class="rulebook-app">

  <app-panel-header-image-view pretitle="{{'Sport' | transloco}}" [title]="title | transloco"
    banner_image="../../modules/custom/wa_angular/app/assets/images/rulebook/image_book_1.png">
    <!--   <app-third-nav-tab-component [selectedIndex]="selectedIndex" [elements]="ruleBookRoutes"></app-third-nav-tab-component>
-->
  </app-panel-header-image-view>

  <div class="rulebook-app">

    <app-app-content-page-wrapper>

      <router-outlet></router-outlet>

      <div class="rulebook-footer">
        {{ (isDrupal ? 'rulebook_intro_interpretation_drupal' : 'rulebook_intro_interpretation') | transloco}} <a
          href="https://documents.worldarchery.sport/?doc=977" target="_blank">{{(isDrupal ?
          'interpretation_request_drupal' : 'interpretation_request') | transloco}}</a>.
      </div>

    </app-app-content-page-wrapper>

  </div>

</div>
